import { render } from "./CtfCard.vue?vue&type=template&id=2fddb51e&scoped=true&ts=true"
import script from "./CtfCard.vue?vue&type=script&lang=ts"
export * from "./CtfCard.vue?vue&type=script&lang=ts"

import "./CtfCard.vue?vue&type=style&index=0&id=2fddb51e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fddb51e"]])

export default __exports__